import {COUNTRY_CODES, type CountryCode} from './countryCodes';

type LanguageDefinition = {
  readonly href: string;
  readonly englishName: string;
  readonly lang: string;
  readonly direction: `ltr` | `rtl`;
  readonly countryCodes: readonly CountryCode[];
};

export const LANGUAGE_DEFINITIONS = {
  'en-US': {
    href: `/`,
    englishName: `English/United States`,
    lang: `en`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.US],
  },
  'en-KE': {
    href: `/en-KE`,
    englishName: `English/Kenya`,
    lang: `en-KE`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.KE],
  },
  'en-NG': {
    href: `/en-NG`,
    englishName: `English/Nigeria`,
    lang: `en-NG`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.NG],
  },
  'en-SG': {
    href: `/en-SG`,
    englishName: `English/Singapore`,
    lang: `en-SG`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.SG],
  },
  'pt-PT': {
    href: `/pt-PT`,
    englishName: `Portuguese/Portugal`,
    lang: `pt`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.PT],
  },
  'pt-BR': {
    href: `/pt-BR`,
    englishName: `Portuguese/Brazil`,
    lang: `pt-BR`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.BR],
  },
  'de-DE': {
    href: `/de-DE`,
    englishName: `German/Germany`,
    lang: `de`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.DE],
  },
  'de-AT': {
    href: `/de-AT`,
    englishName: `German/Austria`,
    lang: `de-AT`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.AT],
  },
  'de-CH': {
    href: `/de-CH`,
    englishName: `German/Switzerland`,
    lang: `de-CH`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.CH],
  },
  'es-ES': {
    href: `/es-ES`,
    englishName: `Spanish/Spain`,
    lang: `es`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.ES],
  },
  'fr-FR': {
    href: `/fr-FR`,
    englishName: `French/France`,
    lang: `fr`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.FR],
  },
  'it-IT': {
    href: `/it-IT`,
    englishName: `Italian/Italy`,
    lang: `it`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.IT],
  },
  'nl-NL': {
    href: `/nl-NL`,
    englishName: `Dutch/Netherlands`,
    lang: `nl`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.NL],
  },
  'pl-PL': {
    href: `/pl-PL`,
    englishName: `Polish/Poland`,
    lang: `pl`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.PL],
  },
  'sv-SE': {
    href: `/sv-SE`,
    englishName: `Swedish/Sweden`,
    lang: `sv`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.SE],
  },
  'da-DK': {
    href: `/da-DK`,
    englishName: `Danish/Denmark`,
    lang: `da`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.DK],
  },
  'fi-FI': {
    href: `/fi-FI`,
    englishName: `Finnish/Finland`,
    lang: `fi`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.FI],
  },
  'no-NO': {
    href: `/no-NO`,
    englishName: `Norwegian/Norway`,
    lang: `no-NO`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.NO],
  },
  'is-IS': {
    href: `/is-IS`,
    englishName: `Icelandic/Iceland`,
    lang: `is`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.IS],
  },
  'ja-JP': {
    href: `/ja-JP`,
    englishName: `Japanese/Japan`,
    lang: `ja`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.JP],
  },
  'ko-KR': {
    href: `/ko-KR`,
    englishName: `Korean/South Korea`,
    lang: `ko`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.KR],
  },
  'zh-Hans-CN': {
    href: `/zh-Hans-CN`,
    englishName: `Mandarin/China`,
    lang: `zh-Hans`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.CN],
  },
  'yue-Hant-HK': {
    href: `/yue-Hant-HK`,
    englishName: `Cantonese/Hong Kong`,
    lang: `yue-Hant-HK`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.HK],
  },
  'vi-VN': {
    href: `/vi-VN`,
    englishName: `Vietnamese/Vietnam`,
    lang: `vi`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.VN],
  },
  'th-TH': {
    href: `/th-TH`,
    englishName: `Thai/Thailand`,
    lang: `th`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.TH],
  },
  'id-ID': {
    href: `/id-ID`,
    englishName: `Indonesian/Indonesia`,
    lang: `id`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.ID],
  },
  'sw-KE': {
    href: `/sw-KE`,
    englishName: `Swahili/Kenya`,
    lang: `sw-KE`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.KE],
  },
  'hi-IN': {
    href: `/hi-IN`,
    englishName: `Hindi/India`,
    lang: `hi`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.IN],
  },
  'bn-BD': {
    href: `/bn-BD`,
    englishName: `Bengali/Bangladesh`,
    lang: `bn-BD`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.BD],
  },
  'mr-IN': {
    href: `/mr-IN`,
    englishName: `Marathi/India`,
    lang: `mr`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.IN],
  },
  'te-IN': {
    href: `/te-IN`,
    englishName: `Telugu/India`,
    lang: `te`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.IN],
  },
  'fa-IR': {
    href: `/fa-IR`,
    englishName: `Farsi/Iran`,
    lang: `fa`,
    direction: `rtl`,
    countryCodes: [COUNTRY_CODES.IR],
  },
  'ur-PK': {
    href: `/ur-PK`,
    englishName: `Urdu/Pakistan`,
    lang: `ur`,
    direction: `rtl`,
    countryCodes: [COUNTRY_CODES.PK],
  },
  'pa-PK': {
    href: `/pa-PK`,
    englishName: `Punjabi/Pakistan`,
    lang: `pa-Arab-PK`,
    direction: `rtl`,
    countryCodes: [COUNTRY_CODES.PK],
  },
  'pcm-NG': {
    href: `/pcm-NG`,
    englishName: `Nigerian Pidgin/Nigeria`,
    lang: `pcm-NG`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.NG],
  },
  'tr-TR': {
    href: `/tr-TR`,
    englishName: `Turkish/Turkey`,
    lang: `tr`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.TR],
  },
  'ru-RU': {
    href: `/ru-RU`,
    englishName: `Russian/Russia`,
    lang: `ru`,
    direction: `ltr`,
    countryCodes: [COUNTRY_CODES.RU],
  },
  'ar-SA': {
    href: `/ar-SA`,
    englishName: `Arabic/Gulf`,
    lang: `ar`,
    direction: `rtl`,
    countryCodes: [COUNTRY_CODES.SA],
  },
  'ar-AE': {
    href: `/ar-AE`,
    englishName: `Arabic/United Arab Emirates`,
    lang: `ar-AE`,
    direction: `rtl`,
    countryCodes: [COUNTRY_CODES.AE],
  },
  'ar-QA': {
    href: `/ar-QA`,
    englishName: `Arabic/Qatar`,
    lang: `ar-QA`,
    direction: `rtl`,
    countryCodes: [COUNTRY_CODES.QA],
  },
  'ar-MA': {
    href: `/ar-MA`,
    englishName: `Moroccan Arabic/Morocco`,
    lang: `ary`,
    direction: `rtl`,
    countryCodes: [COUNTRY_CODES.MA],
  },
} as const satisfies Record<string, LanguageDefinition>;

export type LanguageId = keyof typeof LANGUAGE_DEFINITIONS;

export type LanguageHref = (typeof LANGUAGE_DEFINITIONS)[LanguageId][`href`];

export const languageHref = <Id extends LanguageId>(id: Id): (typeof LANGUAGE_DEFINITIONS)[Id][`href`] => LANGUAGE_DEFINITIONS[id].href;

const ensureLanguageOrder = <T extends readonly LanguageId[]>(languageIds: T): T => {
  if (languageIds.length === 0) {
    throw new Error(`Microsite route manifests must declare at least one locale.`);
  }

  const seen = new Set<LanguageId>();
  languageIds.forEach((languageId) => {
    if (!Object.prototype.hasOwnProperty.call(LANGUAGE_DEFINITIONS, languageId)) {
      throw new Error(`Microsite declared unsupported locale "${languageId}".`);
    }
    if (seen.has(languageId)) {
      throw new Error(`Microsite declared duplicate locale "${languageId}".`);
    }
    seen.add(languageId);
  });

  return languageIds;
};

export const defineLanguageOrder = <T extends readonly LanguageId[]>(languageIds: T): T => ensureLanguageOrder(languageIds);

export const validateLanguageOrder = <T extends readonly LanguageId[]>(languageIds: T): T => ensureLanguageOrder(languageIds);
